import { render } from "./MyJsplumb.vue?vue&type=template&id=260d3e4a"
import script from "./MyJsplumb.vue?vue&type=script&lang=js"
export * from "./MyJsplumb.vue?vue&type=script&lang=js"

import "./MyJsplumb.vue?vue&type=style&index=0&id=260d3e4a&lang=css"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__